'use es6';

import { BaseResponsiveColumnToolbar, buildActionsForColumn } from './BaseResponsiveColumnToolbar';

/**
 * @param {string} props.responsiveSize (required)
 * @param {boolean} props.isInNonDefaultBreakpointMode (required)
 * @param {boolean} props.isInDeveloperMode (optional)
 */
import { jsx as _jsx } from "react/jsx-runtime";
const MockResponsiveMobileColumnToolbarToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode,
  isInDeveloperMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveColumnToolbar, {
    active: false,
    actions: buildActionsForColumn({
      isInDefaultBreakpointMode: !isInNonDefaultBreakpointMode,
      isInDeveloperMode
    }),
    responsiveSize: responsiveSize
  });
};

/**
 * @param {string} props.responsiveSize (required)
 * @param {boolean} props.isInNonDefaultBreakpointMode (required)
 * @param {boolean} props.isInDeveloperMode (optional)
 */
const MockResponsiveDesktopColumnToolbarToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode,
  isInDeveloperMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveColumnToolbar, {
    active: false,
    actions: buildActionsForColumn({
      isInDefaultBreakpointMode: !isInNonDefaultBreakpointMode,
      isInDeveloperMode
    }),
    responsiveSize: responsiveSize
  });
};
export { MockResponsiveMobileColumnToolbarToMeasure, MockResponsiveDesktopColumnToolbarToMeasure };